<template>
  <div>
    <HeadDetailsGama @nextstatus="$emit('nextstatus')"   :btnCanceSave="false" :titleHead="'Lista de Chamados'"></HeadDetailsGama>
    <div class="body-documents-image">
        <div class="d-flex justify-content-between mb-3">
            <div class="d-flex gap-1 input-search">
              <div>
                <i class="fas fa-search icone-search"></i>
                <input v-model="searchFile" class="form-control input-search-p" placeholder="Pesquisar arquivo">
              </div>
              <div>
                <button  @click="openmodalnewgroup" class="button-outiline"><i class="fas fa-plus-circle mr-2"></i>Novo Grupo</button>
              </div>
              <div>
                <button @click="downloadGroup" class="button-head-documents"  v-b-tooltip="'Download'" ><i class="fas fa-download"></i></button>
              </div>
            </div>
        </div>
         <div class="body-documents">
            <div v-if="searchFile === ''">
              <div v-for="data in dataallgroup" :key="data.id">
              <CollapseImageDocumets @imageDetails="imageDetails" @removeImg="RemoveImgArquivoGroup" :flAdd="true" :title="data.nome" :dataImg="data.reGroupImageArquivos" :id="data.id" >
              <input :id="'check-' + data.id" class="form-control form-inputcheck" type="checkbox"  />
                <template v-slot:newPick>
                  <div class="add-new-photo"
                    @dragover.prevent.stop="onDragOver(data.id)" :id="'drop-' + data.id"
                    @dragleave.prevent.stop="onDragLeave(data.id)" @drop.prevent="SendFileArquivo">
                    <i class="fas fa-cloud-upload-alt cloud-font"></i>
                    <button class="import-file w-75" @click="openinputfilegroup(data.id)">IMPORTE UM ARQUIVO</button>
                    <p class="description-drop-input">ou arraste o arquivo aqui</p>
                     <input @change="SendFileArquivo" type="file" :id="'file-' + data.id" class="file-hidden" />
                    </div>
                </template>
              </CollapseImageDocumets>
            </div>
            </div>
            <div v-else class="img-flex">
                  <div   v-for="(data, index) in datafilefilter" v-bind:key="index" :class="{'img-body':true}">
                    <div  v-on:click="imageDetails(data.arquivo, data.extensaos === null ?null : data.extensaos == 'pdf' ? true : data.extensaos == 'mp4' ? null : false)"  class="h-100 img-flex-dir">
                    <i v-if="data.extensaos == 'pdf'" style="font-size: 70px" class="fas fa-file-pdf icone"></i>
                    <i v-else-if="data.extensaos == 'mp4'" style="font-size: 70px" class="fas fa-video icone"></i>
                    <img v-else class="mb-2 img-body-body" :src="'data:image/jpeg;base64,' + data.arquivo">
                    <div class="img-footer">
                      <div  class="img-title">{{data.descricao == null ? 'N/D' : data.descricao}}</div>
                    </div>
                    </div>
                    <div class="edit-img" v-on:click="RemoveImgArquivoGroup(data.arquivoId)">
                      <i class="fas fa-times"></i>
                    </div>
                  </div>
            </div>
          </div>
    </div>
    <!-- <b-modal
    ref="modalnewFile"
      hide-footer
      :title="'Adicionar novo Arquivo'"
      size="lg"
      centered>
      <div class="modal-body-cus">
        <p class="sub-title">Selecione o arquivo que desejar enviar</p>
        <div class="custom-drop">
           <div class="w-50 custom-drop-down">
             <i class="fas fa-cloud-upload-alt cloud-font"></i>
             <button class="import-file" @click="openinputfile">IMPORTE UM ARQUIVO</button>
             <p class="description-drop-input">ou solte o arquivo aqui</p>
             <input type="file" class="file-hidden" />
           </div>
        </div>
          <p class="sub-title">Grupo destino</p>
          <select class="form-control">
            <option :value="null"> Selecione o arquivo que desejar enviar</option>
            <option v-for="data in dataallgroup" :key="data.id" :value="data.id">{{data.nome}}</option>
          </select>
          <div class="button-modal">
            <button @click="closepoupmodalnewFile" class="button-cancel">
              Cancelar
            </button>
            <button class="button-save" @click="onSubmit">ADICIONAR</button>
          </div>
      </div>
    </b-modal> -->
       <b-modal
        ref="modalnewgroup"
        hide-footer
        centered>
        <template #modal-title>
          <div class="header-title">ADICIONAR NOVO GRUPO</div>
        </template>
        <div class="modal-new-group">
            <p class="sub-title">Digite o nome do novo grupo de documentos</p>
            <input class="form-control" v-model="newNameGroup" />
            <div class="button-modal">
            <button @click="closemodalnewgroup" class="button-cancel mr-1">
              Cancelar
            </button>
            <button class="button-save ml-1" @click="SaveGroup">ADICIONAR</button>
          </div>
    </div>
       </b-modal>
         <b-modal ref="modalDetails" hide-footer hide-header id="modal-center" centered title="BootstrapVue">
          <div v-if="!ispdf">
            <img class="img-modal-details" :src="'data:image/jpeg;base64,' + imgDetails">
          </div>
          <div v-if="ispdf" class="modal-pdf">
            <iframe
              style="overflow: hidden"
              id="pdfViewer"
              width="100%"
              scrolling="no"
              class="mb-2 img-body-body pdf-overview"
              :src="'data:application/pdf;base64,'+ imgDetails + '#toolbar=0&navpanes=0&scrollbar=0'" frameborder="0">
            </iframe>
          </div>
      </b-modal>
  </div>
</template>

<script>
import documentoccourences from './documentoccourences'
export default documentoccourences
</script>

<style scoped>
.header-title{
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}
.cloud-font{
    font-size: 3.5rem;
    color: #008148;
    margin-bottom: 10px;
}
.add-new-photo{
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  margin-left: 2%;
  width: 270px;
  height: 185px;
  border-radius: 10px;
  border: 1px dashed black ;
}
.modal-pdf{
  height: 70vh;
}
.img-body-body{
  position: relative;
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
  z-index: 0;
}
.img-body{
  width: 270px;
  height: 185px;
  border-radius: 10px;
  position: relative;
  transition: 400ms;
  margin-bottom: 15px;
  cursor: pointer;
  margin-left: 2%;

}
.img-modal-details{
  height: fit-content;
  object-fit: cover;
  width: 100%;
}
.sub-title{
    margin-top: 25px;
    font-size: 15px;
    font-weight: bold;
    line-height: 0px;
    font-family: 'Segoe UI';
}
.img-title {
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 75%;
  text-align: center;
  overflow: hidden;
}
.edit-img{
  height: 34px;
  top: 0px;
  z-index: 5;
  right: 0px;
  width: 40px;
  color: white;
  background-color: red;
  border-radius: 0px 8px 0px 15px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-footer{
  position: absolute;
  width: 100%;
  height: 30px;
  color: white;
  background: rgba(0, 0, 0, 0.644);
  bottom: 0px;
  border-radius: 0px 0px 10px 10px;
  display: flex;
  justify-content: center;
  align-content: center;
}
.img-flex-dir{
    display: flex;
    justify-content: center;
    align-items: center;
}
.img-flex{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.img-body-body{
  position: relative;
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
  z-index: 0;
}
.body-documents{
  height: 60vh;
  overflow: auto;
  font-family: 'Segoe UI'
}

.form-inputcheck{
  position: absolute;
  accent-color:#008148;
  width: 20px;
  height: 20px;
  left: 5px;
  top: 8px;
}
.modal-body-cus{
    padding: 25px;
    height: 50vh;
    width: 100%;
}
.file-hidden{
    visibility: hidden;
}
.import-file{
    /* width: 100%;
    border: 1px solid #008148;
    height: 40px;
    font-size: 12px;
    font-weight: bold;
    border-radius: 5px;
    margin-bottom: 10px;
    background-color: #008148;
    color: rgb(239, 239, 239); */

    border: 1px transparent;
    height: 1.5rem;
    font-size: 12px;
    font-weight: bold;
    border-radius: 5px;
    background: transparent;
    color: #008148;
}
.modal-new-group{
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-content: center;
}
.button-modal{
    display: flex;
    margin-top: 25px;
    align-items: center;
    height: 10vh;
    justify-content: space-evenly;

}
.description-drop-input{
    font-size: 13px;
    color: #008148;
}
.custom-drop-down{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.button-cancel,
.button-save{
  margin-top: 10;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 240px;
  height: 40px;
  font: bold 14px 'Segoe UI';
}
.button-save{
  background-color: #008148;
  color: white;
  font-family: 'Segoe UI';
  font-size: 14px;
}

.button-cancel{
  background-color: #dedede;
  color: #747474;
}
.custom-drop{
    width: 100%;
    display: flex;
    justify-items: center;
    height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #00000029;
    border-radius: 10px;
    border: 1px dashed #00000029;
}
.input-search{
    width: 100%;
    display: flex;
    position: relative;
    gap: 1rem;
}
.button-outiline{
    height: 35px;
    width: 135px;
    font-size: 14px;
    color: #008148;
    font-weight: bold;
    background: none;
    border: 1px solid #008148;
    border-radius: 5px;
    font-family:'Segoe UI'
}
.icone-search{
    position: absolute;
    left: 10px;
    top: 10px;
    font-size: 14px;
}
.input-search-p{
    padding-left: 30px;
    width: 20rem;
    border-radius: 5px;
}
.body-documents-image{
    padding-top: 25px;
    height: 100%;
    /* border: 1px solid gray;
    padding: 15px; */
}
.inputs-head{
    display: flex;
    width: 20%;
    justify-content: space-evenly;
}
.button-head-documents{
    background: #008148;
    font-size: 14px;
    height: 35px;
    justify-content: center;
    align-items: center;
    border: none;
    width: 40px;
    color: white;
    border-radius: 5px;
}

@media  (max-width: 1280px) {
  .button-outiline{
    height: 35px;
    width: 135px;
    font-size: 12px;
    color: #008148;
    font-weight: bold;
    background: none;
    border: 1px solid #008148;
}
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/documentoccourences/documentoccourences.vue